<template>
    <header class="fixed-top">
        <!-- Start Navbar -->
        <nav class="navbar navbar-expand-lg navbar-dark bg-black">
            <!-- Start Container -->
            <div class="container">
                <a href="#" class="navbar-brand" @click.prevent="reloadPage()">
                    AX<span>IT</span>
                </a>
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="navbarNav">
                    <ul class="navbar-nav">
                        <li
                            class="nav-item"
                            @click="handleLinks"
                            v-for="routerLinkData in routerLinksData"
                            :key="routerLinkData.id"
                        >
                            <router-link
                                :to="routerLinkData.path"
                                class="nav-link"
                                aria-current="page"
                                active-class
                                exact-active-class
                            >
                                {{ routerLinkData.textContent }}
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- End Container -->
        </nav>
        <!-- End Navbar -->
    </header>
</template>

<style scoped lang="scss">

    .navbar{
        padding: {
            top: 0;
            bottom: 0
        }
    }

    .navbar-expand-lg{
        .navbar-brand{
            font-size: 40px;
            padding: {
                top: 0;
                bottom: 0
            }
            color: rgba(255,255,255,.55);
            span{
                color: var(--main-color)
            }
        }
        .navbar-nav{
            flex-basis: 100%;
            justify-content: right;
            .nav-link{
                @media(min-width: 992px){
                    padding-right: 1rem
                }
            }
        }
    }

</style>

<script>

// Get Data From Json File

import {router_links_data} from "../../../assets/jsonData/index.json"

export default {

    name: "Header",

    data: function (){

        return {

            routerLinksData: router_links_data
            
        }
    },

    methods: {

        /* Reload The Page On Click The Brand In Navbar (AXIT) */

        reloadPage(){

            window.location.reload()

        },

        /* ------------------------------------------------------------ */

        /* Add Color To Active Link On Click it */

        handleLinks(e){

            const links = document.querySelectorAll(".navbar-expand-lg .navbar-nav .nav-link")

            links.forEach(link => {

                link.style.color = ""

                e.target.style.color = "var(--main-color)"
                
            })
        },

        /* ------------------------------------------------------------ */
    }
}

</script>